import * as React from 'react';
import * as styles from './PaymentStatus.css';
import { useDeviceCondition } from '../../../../hooks';
import classNames from 'classnames';
import { PaymentStatusCanceled, PaymentStatusPending, PaymentStatusSucceeded } from './components';
import { EPaymentStatus } from '../../../../types/reducers/paymentProcessing';

interface IProps {
  status: EPaymentStatus;
  handleRetryClick(): void;
}

export const PaymentStatus = (props: IProps) => {
  const { status, handleRetryClick } = props;

  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(styles['wrapper'], rootStyle)}>
      {status === EPaymentStatus.Pending && <PaymentStatusPending />}

      {status === EPaymentStatus.Succeeded && <PaymentStatusSucceeded />}

      {status === EPaymentStatus.Canceled && <PaymentStatusCanceled onClick={handleRetryClick} />}
    </div>
  );
};
